var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMasonry = function SvgMasonry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14v5H8v-5h11ZM6 14v5H0v-5h6Zm5-7v5H0V7h11Zm8 0v5h-6V7h6ZM6 0v5H0V0h6Zm13 0v5H8V0h11Z",
    fill: "#191919",
    fillRule: "evenodd"
  })));
};
export default SvgMasonry;